import get from 'lodash/get';

const singleDigitRegex = /\d/;
const notDigitRegex = /[^\d]/g;
const leadingZeroesRegex = /^0+([1-9]+\d*)/;
const thousandPlacesRegex = /\B(?=(\d{3})+(?!\d))/g;
const onlyZerosRegex = /^0+$/;

export const getCursorPos = (val, posInValue, symbolLength) => {
  let i = 0;
  let cursorPos = 0;
  const len = val.length;

  while (i < posInValue && cursorPos < len) {
    if (singleDigitRegex.test(val.charAt(cursorPos))) {
      i++;
    }
    cursorPos++;
  }

  return Math.max(symbolLength + 1, cursorPos);
};

export const format = (value, props) => {
  let output = value.trim();
  output = output.replace(thousandPlacesRegex, props.thousandSeparator);
  output = `${props.symbol}${output}`;
  return `${output} M.N.`;
};

export const unformat = value => {
  let output = value.replace(notDigitRegex, '');
  output = output.replace(leadingZeroesRegex, '$1');
  output = output.replace(onlyZerosRegex, '0');
  return output;
};

export const formatAmountFromPath = (obj, path) => {
  let amount = get(obj, path);
  if (amount === undefined || amount === null) {
    return '';
  }
  if (typeof(amount) === 'number') {
    amount = amount.toFixed(2);
  }
  return format(amount.toString(), { thousandSeparator: ',', symbol: '$' });
};
